import OrderSectionErrorsSummary from "features/trades/common/OrderSectionErrorsSummary";
import ExistingQuantityOrder from "features/tradingTerminal/Orders/ExistingQuantityOrder";
import React, { useContext } from "react";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { OrderTypes } from "@shared/features/trades/common/types";
import { StyledCardSorters } from "../common/styles";
import { useTheme } from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface ExistingOrderTableProps {
  orderType: OrderTypes;
}

const ExistingOrderTable = ({ orderType }: ExistingOrderTableProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const theme = useTheme();
  const { quantity, existingQuantityErrors } = useContext(
    TradingTerminalContext
  )!;

  const showExistingQuantityOrder = !!(
    orderType === OrderTypes.ENTRY &&
    quantity &&
    quantity !== "0"
  );

  return (
    <>
      {showExistingQuantityOrder && (
        <>
          {Object.keys(existingQuantityErrors).length > 0 && (
            <OrderSectionErrorsSummary
              errors={existingQuantityErrors}
              orderType={OrderTypes.ENTRY}
            />
          )}
          <StyledCardSorters
            columnNames={[
              t("table_headers.price"),
              t("table_headers.existing_amount"),
            ]}
            columnSpans={[12, 12]}
            sorterStyle={{ color: theme.colors.primaryText }}
          />
          <ExistingQuantityOrder />
        </>
      )}
    </>
  );
};

export default ExistingOrderTable;
